export default (urlParameters) => {
  return {
    allow_forecast_map_obs_markers: true,
    customize_map_button_default: true,
    customize_map_button: true,
    detail_panel: true,
    drawing_tools: true,
    forcast_model_run_selector: true,
    map_auto_refresh: true,
    map_custom_layers: true,
    map_name_block: true,
    map_selector_button: true,
    mesonet_filter_button: true,
    mesonet_filter: true,
    pinned_map_bar: true,
    spot_obs_parameters: true,
    storm_header_block: true,
    storm_map_selector_button: true,
    storm_spaghetti_map: true,
    ui_storage_name: 'opsConStormMapUIStore'
  }
}